import {
  AutoComplete,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Select,
  message,
  Upload,
  Button,
  Row,
  Col,
  Tooltip,
  Space,
} from "antd";
import { FormInstance } from "antd/lib/form/Form";
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { Item } from "types/models/colums-table-type";
import type { InputRef } from "antd";
import {
  FIELD_TYPE,
  FORMAT_TIME,
  LOAI_DON_THUOC,
  LOAI_FORM,
  LOAI_PHIEU_VTYT,
  TT_PHIEU_KHO,
} from "types/enums";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { employeeService } from "api";
import { DownloadOutlined, UploadOutlined } from "@ant-design/icons";
import moment from "moment";
import InputCode from "components/common/Code/Code";
import { setListThuocByName } from "redux/reducer/tableAdd";
import {
  formatDateToString,
  generateFileName,
  removeObjUndefined,
} from "helper/common";
import { setTypeForm } from "redux/reducer/pharmacyStore";
import { Rule } from "antd/es/form";
import { columns as suppliesDetailColumns } from "../Tab1/config";
import {
  getStoreVTYTSearchKeyAPI,
  medicalSuppliesStore,
} from "redux/reducer/medicalSupplies";
import Notification from "components/common/notification/notification";
import { setData } from "redux/reducer/pending";
import { setLoading } from "redux/reducer/medicineStore";
import { searchTraning } from "redux/reducer/employee";
import Icons from "assets/icons";
import axiosClient from "api/axiosClient";
type EditableRowProps = {
  index: number;
};

const {
  INPUT,
  SELECT,
  NUMBER,
  DATE,
  AUTO_COMPLETE,
  COMBO_BOX,
  CURRENCY,
  CODE,
} = FIELD_TYPE;
export type EditableCellProps = {
  id: any;
  title: React.ReactNode;
  editable?: boolean;
  children: React.ReactNode;
  dataIndex: any;
  record: any;
  selected: boolean;
  options: any;
  name: string;
  index: number;
  type: FIELD_TYPE;
  disabled?: boolean;
  value?: any;
  onChange?: (e) => void;
  handleSave: (record, index) => void;
  onFocus?: () => void;
  onPressEnter?: (e) => void;
  addonAfter?: any;
  rules?: Rule[];
  hidden?: boolean;
  autoFocus?: boolean;
};

export const EditableContext = React.createContext<FormInstance<any> | null>(
  null
);

export const EditableRow: React.FC<EditableRowProps> = ({
  index,
  ...props
}) => {
  const [form] = Form.useForm();
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};

export const EditableCell: React.FC<EditableCellProps> = ({
  id,
  title,
  editable,
  children,
  dataIndex,
  record,
  selected,
  options,
  handleSave,
  name,
  index,
  type,
  onChange,
  onPressEnter,
  disabled,
  value,
  hidden,
  autoFocus,
  ...restProps
}) => {
  const form = useContext(EditableContext)!;

  const [inputValue, setInputValue] = useState({});
  const [newOptions, setNewOptions] = useState(options);
  const dispatch = useAppDispatch();
  let childNode = children;

  useEffect(() => {
    if (dataIndex == "idNhanVien") {
      setListEmp();
    }
  }, []);

  const handleSetFieldValue = (dataIndex, value) => {
    form.setFieldValue(dataIndex, value);
    setInputValue({ ...inputValue, [dataIndex]: value });
    handleSave(form.getFieldsValue(), index);
  };
  const employees = useAppSelector((state) => state.employeesReducer);
  const setFieldsValueByKey = (data, cellName) => {
    suppliesDetailColumns.forEach((column) => {
      const columnName = column.dataIndex;
      if (columnName !== cellName) {
        handleSetFieldValue(columnName, data?.[String(columnName)]);
      }
    });
  };
  const handleUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    setLoading(true);
    if (event.target.files && event.target.files.length > 0) {
      const pdf = event.target.files[0];
      const formData = new FormData();
      formData.append("pdfFiles", pdf);
      try {
        if (id === null && id === undefined) {
          Notification("warning", "Vui lòng lưu nhân viên trước khi upload");
          setLoading(false);
        } else {
          const response = await employeeService.uploadFileTraining(
            formData,
            id,
            record?.idNhanVien
          );
          if (response.status == 200) {
          }
          setLoading(false);
          form.setFieldValue("chungChi", pdf.name);
          Notification("success", "tải lên file thành công");
        }
      } catch (err) {
        setLoading(false);
        Notification("error", "Lỗi khi tải lên file");
      }
    }
  };
  const getListEmpAPI = async () => {
    try {
      const res = await employeeService.searchEmployee({
        page: 1,
        limit: 1000,
      });
      return res;
    } catch (error) {
      return [];
    }
  };
  const setListEmp = async () => {
    setLoading(true);
    if (dataIndex == "idNhanVien") {
      try {
        const res = await getListEmpAPI();
        const listEmp = res?.items;
        const EmpOptions = listEmp?.map((e) => ({
          value: e.id,
          label: e.hoTen,
          key: `${e.id}-${e.hoTen}`,
        }));

        setNewOptions(EmpOptions);
      } catch (error) {
        setNewOptions([]);
      }
    }
    setLoading(false);
  };
  const handleDownload = async () => {
    const url = `hanhchinhnhansu/khoa-dao-tao/download-file-chung-chi?idKhoaDaoTao=${id}&idNhanVien=${record.idNhanVien}`;
    const baseName = form.getFieldValue("chungChi");
    const fileExtension = "pdf";
    const fileName = generateFileName(baseName, fileExtension);
    // const params = {
    //   id: data.id,
    // };
    try {
      const response = await axiosClient.get(url, {
        responseType: "blob",
      });

      const blob = await response.data;

      // Create a blob URL
      const blobUrl = window.URL.createObjectURL(blob);

      // Create a link element for downloading
      const downloadLink = document.createElement("a");
      downloadLink.href = blobUrl;
      downloadLink.download = fileName;

      // Append the link to the document, trigger click, and remove the link
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } catch (error) {
      // Handle the error, e.g., show an error message to the user
      Notification("error", "Error exporting pdf");
    }
  };
  const getDetailsEmployee = async (id) => {
    try {
      const res = await employeeService.getEmployee(id);
      handleSetFieldValue("maNhanVien", res?.maNhanVien);
    } catch (error) {
      handleSetFieldValue("maNhanVien", {});
    }
  };
  const getDetailsPhongBan = async (id) => {
    try {
      const res = await employeeService.getContract(id);
      if (res !== null && res !== "") {
        const phongBan = res[0].phongBan;
        handleSetFieldValue("phongBan", phongBan);
      } else {
        handleSetFieldValue("phongBan", null);
      }
    } catch (error) {
      handleSetFieldValue("phongBan", null);
    }
  };
  const fileInputRef = useRef<HTMLInputElement>(null);
  const handleClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };
  if (type == INPUT) {
    childNode = (
      <Form.Item
        name={dataIndex}
        initialValue={record ? record[dataIndex] : null}
      >
        <Input
          disabled={disabled}
          placeholder={disabled ? "--" : "Nhập"}
          onChange={async (e) => {
            setInputValue({ ...inputValue, [dataIndex]: e.target.value });
            handleSave(form.getFieldsValue(), index);
          }}
        ></Input>
      </Form.Item>
    );
  }
  if (type === "NUMBER") {
    childNode = (
      <Form.Item
        name={dataIndex}
        initialValue={record ? record[dataIndex] : null}
        style={{ textAlign: "center" }}
      >
        <Row gutter={[16, 16]}>
          <Col xl={2} lg={2}>
            <Tooltip title={"Upload "}>
            </Tooltip>
          </Col>
        </Row>
        <input
          type="file"
          style={{ display: "none" }}
          onChange={handleUpload}
          ref={fileInputRef}
          accept=".pdf"
        />
        <Space>
        <Button
          icon={<Icons.upload />}
          className="btn-upload"
          type="dashed"
          onClick={handleClick}
          style={{
            width: "100px",
            border: "1px solid #00B335",
            margin:"center",
            color: "#00B335",
          }}
        >
          Upload
        </Button>
        <Button
          icon={<DownloadOutlined />}
          onClick={handleDownload}
          style={{
            width: "120px",
            border: "1px solid #00B335",
            color: "#00B335",
            margin:"center",
            marginLeft: "10px",
          }}
        >
          Tải xuống
        </Button>
        </Space>
      </Form.Item>
    );
  }

  // if (type == "NUMBER") {
  //   childNode = (
  //     <Form.Item
  //       name={dataIndex}
  //       initialValue={record ? record[dataIndex] : null}
  //       style={{ textAlign: "center" }}
  //     >
  //       <input
  //         type="file"
  //         style={{ display: "none" }}
  //         onChange={handleUpload}
  //         ref={fileInputRef}
  //         accept=".pdf"
  //       />
  //       <Button
  //         icon={<Icons.upload rev={0} />}
  //         className="btn-upload"
  //         type="dashed"
  //         onClick={handleClick}
  //         style={{
  //           width: "130px",
  //           border: "1px solid #00B335", // Đặt màu viền xanh
  //           color: "#00B335", // Đặt màu chữ xanh tương ứng
  //         }}
  //       >
  //         Upload CV
  //       </Button>
  //       {/* <Upload
  //         disabled={disabled}
  //         beforeUpload={() => false}
  //         listType="text"
  //        // customRequest={(handleUpload)}
  //       >
  //         <Button icon={<UploadOutlined rev={undefined} />} disabled={disabled}>
  //           Chọn File
  //         </Button>
  //       </Upload> */}
  //     </Form.Item>
  //   );
  // }
  if (type == COMBO_BOX) {
    childNode = (
      <Form.Item
        style={{ margin: 0 }}
        name={dataIndex}
        initialValue={record ? record[dataIndex] : null}
      >
        <Select
          showSearch
          style={{
            width: "100%",
          }}
          filterOption={(input, option) =>
            (option?.label.toString().toLowerCase() ?? "").includes(
              input.toLowerCase()
            )
          }
          placeholder={disabled ? "--" : "Chọn"}
          options={newOptions}
          disabled={disabled}
          allowClear={true}
          onChange={(e) => {
            setListEmp();
            //setInputValue({ ...inputValue, [dataIndex]: e });
            handleSave(form.getFieldsValue(), index);
            getDetailsEmployee(form.getFieldsValue().idNhanVien);
           // getDetailsPhongBan(form.getFieldsValue().idNhanVien);
          }}
          onClick={async (e) => {
            if (dataIndex == "idNhanVien") {
             // setListEmp();
              handleSave(form.getFieldsValue(), index);
            }
          }}
        //  {...restProps}
        />
      </Form.Item>
    );
  }

  return <td {...restProps}>{childNode}</td>;
};
